import { render, staticRenderFns } from "./ThreadUpload.vue?vue&type=template&id=1d8c153c"
import script from "./ThreadUpload.vue?vue&type=script&lang=js"
export * from "./ThreadUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports